import RegistrationStepFive from './steps/RegistrationStepFive';
import RegistrationStepFour from './steps/RegistrationStepFour';
import RegistrationStepOne from './steps/RegistrationStepOne';
import RegistrationStepThree from './steps/RegistrationStepThree';
import RegistrationStepTwo from './steps/RegistrationStepTwo';

const RegistrationSteps = [
    {
        label: 'Membership Confirmation (Your name must match your BCT membership application)',
        Inputs: RegistrationStepOne
    },
    {  
        label: 'Registration Type',
        Inputs: RegistrationStepTwo
    },
    {
        label: 'Package Selection & Pricing',
        Inputs: RegistrationStepThree
    },
    {
        label: 'Your Information',
        Inputs: RegistrationStepFour
        },
    { 
        label: 'Payment',
        Inputs: RegistrationStepFive
    }
];

export default RegistrationSteps;